import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Uses the current i18n language to determine the currency.
 *
 * - pt → BRL (R$)
 * - Everything else → USD ($)
 */
export function useCurrency() {
  const { i18n } = useTranslation();
  const lang = i18n.language || '';

  return useMemo(() => {
    const isBRL = lang.startsWith('pt');
    const currency = isBRL ? 'brl' : 'usd';

    const formatCurrency = (value: number) =>
      new Intl.NumberFormat(isBRL ? 'pt-BR' : 'en-US', {
        style: 'currency',
        currency: isBRL ? 'BRL' : 'USD',
      }).format(value);

    return { currency, isBRL, formatCurrency };
  }, [lang]);
}

/**
 * Given a plan object, returns the correct price values
 * based on the currency.
 */
export function getPlanPrices(plan: any, isBRL: boolean) {
  const value = isBRL
    ? Number(plan?.value ?? 0)
    : Number(plan?.value_usd ?? 0);
  const valueYearly = isBRL
    ? Number(plan?.value_yearly ?? 0)
    : Number(plan?.value_yearly_usd ?? 0);

  return { value, valueYearly };
}
